<template>
    <div class="socials-container">
        <p class="title">Now let's link your socials</p>
        <div class="social-info">
            <IconInput
                v-for="input in socialInfoInputs"
                :key="input.identifier"
                :identifier="input.identifier"
                :icon="input.icon"
                :validation="input.validation"
                :placeholder="input.placeholder"
                :error-msg="input.message"
            />
        </div>
        <div class="social-media">
            <p class="title">Social Media</p>
            <IconInput
                v-for="input in dynamicSocialInputs"
                :key="input.identifier"
                :identifier="input.identifier"
                :icon="input.icon"
                :validation="input.validation"
                :placeholder="input.placeholder"
                :error-msg="input.message"
            />

            <button @click="addSocial" class="add-link">Add another social link</button>
        </div>
    </div>
</template>
<script>
    import IconInput from './parts/IconInput.vue'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'Socials',
        components: {
            IconInput
        },
        props: {
            userData: {
                type: Object,
                required: true
            },
            validation: {
                type: Object,
                required: false
            }
        },
        data: () => ({
            socialCount: 1
        }),
        methods: {
            addSocial() {
                if (this.socialCount < this.socialInputs.length) {
                    this.socialCount += 1
                }
            }
        },
        computed: {
            dynamicSocialInputs() {
                return this.socialInputs.slice(0, this.socialCount)
            },
            socialInputs() {
                return [
                    {
                        identifier: 'Instagram',
                        icon: '/images/icons/instagram-grey.svg',
                        validation: this.$v.userData.socials,
                        placeholder: 'Enter your Instagram URL',
                        message: 'Add full URL, ie: www.instagram.com/xxx'
                    },
                    {
                        identifier: 'Facebook',
                        icon: '/images/icons/facebook-grey.svg',
                        validation: this.$v.userData.socials,
                        placeholder: 'Enter your Facebook URL',
                        message: 'Add full URL, ie: www.facebook.com/xxx'
                    },
                    {
                        identifier: 'Tiktok',
                        icon: '/images/icons/tiktok-grey.svg',
                        validation: this.$v.userData.socials,
                        placeholder: 'Enter your Tiktok URL',
                        message: 'Add full URL, ie: www.tiktok.com/xxx'
                    },
                    {
                        identifier: 'Youtube',
                        icon: '/images/icons/youtube-grey.svg',
                        validation: this.$v.userData.socials,
                        placeholder: 'Enter your Youtube URL',
                        message: 'Add full URL, ie: www.youtube.com/xxx'
                    },
                    {
                        identifier: 'Spotify',
                        icon: '/images/icons/spotify-grey.svg',
                        validation: this.$v.userData.socials,
                        placeholder: 'Enter your Spotify URL',
                        message: 'Add full URL, ie: open.spotify.com/xxx'
                    },
                    {
                        identifier: 'Mixcloud',
                        icon: '/images/icons/mix.svg',
                        validation: this.$v.userData.socials,
                        placeholder: 'Enter your Mixcloud URL',
                        message: 'Add full URL, ie: www.mixcloud.com/xxx'
                    },
                    {
                        identifier: 'Soundcloud',
                        icon: '/images/icons/soundcloud-grey.svg',
                        validation: this.$v.userData.socials,
                        placeholder: 'Enter your Soundcloud URL',
                        message: 'Add full URL, ie: www.soundcloud.com/xxx'
                    }
                ]
            },
            socialInfoInputs() {
                return [
                    {
                        identifier: 'slug',
                        icon: '/images/icons/hedlyner.svg',
                        validation: this.$v.userData.socialInfo,
                        placeholder: 'Enter your Hedlyner handle',
                        message: 'Please enter alphanumeric characters'
                    },
                    {
                        identifier: 'web_site',
                        icon: '/images/icons/web.svg',
                        validation: this.$v.userData.socialInfo,
                        placeholder: 'Enter your website',
                        message: 'Please enter a correct website'
                    }
                ]
            }
        },
        watch: {
            $v: {
                handler: function (validation) {
                    this.$emit('update:validation', validation)
                },
                immediate: true
            }
        },
        validations: {
            userData: {
                socialInfo: {
                    slug: {
                        required,
                        correctFormat: function (value) {
                            return /^[0-9a-zA-Z\-_]*$/.test(value)
                        }
                    },
                    web_site: {
                        correctFormat: function (value) {
                            return (
                                !value ||
                                /^(https?:\/\/)?(www\.)?[\w.-]+\.[\w.?=&%/-]{2,}$/.test(value)
                            )
                        }
                    }
                },
                socials: {
                    Instagram: {
                        correctFormat: function (value) {
                            return !!(
                                !value ||
                                /^[a-zA-Z0-9-_]+$/.test(value) ||
                                /^(http:\/\/|https:\/\/)?(www.)?[Ii]nstagram.com\/.+$/.test(
                                    value
                                )
                            )
                        }
                    },
                    Facebook: {
                        correctFormat: function (value) {
                            return !!(
                                !value ||
                                /^[a-zA-Z0-9-_]+$/.test(value) ||
                                /^(http:\/\/|https:\/\/)?(www.)?[Ff]acebook.com\/.+$/.test(
                                    value
                                )
                            )
                        }
                    },
                    Tiktok: {
                        correctFormat: function (value) {
                            return !!(
                                !value ||
                                /^[a-zA-Z0-9-_]+$/.test(value) ||
                                /^(http:\/\/|https:\/\/)?(www.)?[Tt]iktok.com\/@.+$/.test(
                                    value
                                )
                            )
                        }
                    },
                    Youtube: {
                        correctFormat: function (value) {
                            return !!(
                                !value ||
                                /^[a-zA-Z0-9-_]+$/.test(value) ||
                                /^(http:\/\/|https:\/\/)?(www.)?[Yy]outube.com\/.+$/.test(
                                    value
                                )
                            )
                        }
                    },
                    Spotify: {
                        correctFormat: function (value) {
                            return !!(
                                !value ||
                                /^[a-zA-Z0-9-_]+$/.test(value) ||
                                /^(http:\/\/|https:\/\/)?open.[Ss]potify.com\/artist\/.+$/.test(
                                    value
                                )
                            )
                        }
                    },
                    Mixcloud: {
                        correctFormat: function (value) {
                            return !!(
                                !value ||
                                /^[a-zA-Z0-9-_]+$/.test(value) ||
                                /^(http:\/\/|https:\/\/)?(www.)?[Mm]ixcloud.com\/.+$/.test(
                                    value
                                )
                            )
                        }
                    },
                    Soundcloud: {
                        correctFormat: function (value) {
                            return !!(
                                !value ||
                                /^[a-zA-Z0-9-_]+$/.test(value) ||
                                /^(http:\/\/|https:\/\/)?(www.)?[Ss]oundcloud.com\/.+$/.test(
                                    value
                                )
                            )
                        }
                    }
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .socials-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 40px;

        .title {
            color: #dedede;
            @include base-font-24;
            font-weight: 600;
            line-height: 28px;
        }
        .social-info {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 16px;
        }
        .social-media {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 16px;

            .title {
                font-size: 20px;
            }
            .add-link {
                padding: 8px 0px;
                background: none;
                width: fit-content;
                color: #8b8b8b;
                @include base-font-14;
                line-height: 115%;
                letter-spacing: 0.14px;
            }
        }
    }
</style>
